import FullPageLayout from "../../../templates/FullPageLayout";
import { Button, Col, Row, Card, Form, Switch } from "antd";
import { useForm } from "react-hook-form";
import { NeedHelp, UploadIcon } from "../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import { InputField, SelectField } from "../../../atoms/FormFields";
import UploadFull from "../../../atoms/UploadPhoto/UploadFull";
import { AutoCompleteField } from "../../../atoms/FormFields/AutoComplete";
import { AddressComponent, Place } from "../../Company/ducks/types";
import { SelectFieldTags } from "../../../atoms/FormFields/SelectFieldTags";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getPropertyFormData } from "../ducks/actions";
import { createProperty } from "../ducks/services";
import SuccessMessage from "../../../atoms/Toasts/SuccessMessage";
import { useNavigate } from "react-router-dom";
import { AxiosError, AxiosResponse } from "axios";
import ErrorMessage from "../../../atoms/Toasts/ErrorMessage";
import PropertyContact from "../Components/AddContact";
import PropertyClient from "../Components/AddClient";
import { uploadUserImage } from "../../MyProfile/ducks/services";
import { RcFile } from "antd/es/upload";
import { SelectedClientType } from "../ducks/types";

interface FormValues {
  name: string;
  address: string;
  select_client: string;
  category_ids: string[];
  address_note: string;
  client_contact_id: string[];
  responsible_for_account: string;
}

export default function AddProperty() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const [checklistFile, setChecklistFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [clientId, setClientId] = useState<string | null>(null);
  const [googleAddress, setGoogleAddress] = useState<Place | null>(null);
  const [selectedClient, setSelectedClient] =
    useState<SelectedClientType | null>(null);
  const [propertyContact, setPropertyContact] = useState<
    { label: string; value: string }[]
  >([]);

  const propertyFormData = useAppSelector(
    (state) => state?.properties?.propertyFormData
  );
  const clientContactData = useAppSelector(
    (state) => state?.properties?.clientContactData
  );

  const {
    control,
    handleSubmit,
    getValues,
    trigger,
    setValue,
    formState: { errors },
  } = useForm<FormValues>();

  const [previewImage, setPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });
  const [modalPreviewImage, setModalPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });

  const saveUpload = () => {
    setLoading(true);
    setPreviewImage({ ...modalPreviewImage });
    setLoading(false);
  };

  useEffect(() => {
    if (companyId) {
      dispatch(getPropertyFormData(companyId));
    }
  }, [companyId, dispatch]);

  useEffect(() => {
    if (clientContactData) {
      const dummyArray: { label: string; value: string }[] = [];
      clientContactData?.map(
        (data: { first_name: string; last_name: string; id: string }) =>
          dummyArray.push({
            label: `${data?.first_name ?? ""} ${data?.last_name ?? ""}`,
            value: data?.id,
          })
      );
      setPropertyContact(dummyArray);
    }
  }, [clientContactData]);

  const onSubmit = (val: FormValues) => {
    setLoading(true);
    let city = "";
    let state = "";
    googleAddress?.address_components?.forEach(
      (component: AddressComponent) => {
        if (component.types.includes("locality")) {
          city = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          state = component.short_name;
        }
      }
    );

    const payload = {
      name: val?.name,
      address: val?.address,
      city: city,
      state: state,
      is_property_billing_address: true,
      address_note: val?.address_note,
      category_ids: val?.category_ids,
      manager_id: val?.responsible_for_account,
      company_id: companyId,
      client_id: val?.select_client,
      client_contact_id: val?.client_contact_id,
    };

    createProperty(payload)
      .then((res: AxiosResponse) => {
        if (checklistFile && res && res?.data?.id) {
          uploadUserImage({
            owner_id: res?.data?.id,
            image: checklistFile as File | RcFile,
            image_type: "property_image",
          })
            .then((res) => {
              if (res) {
                setLoading(false);
                SuccessMessage("Property added.");
                navigate(`/properties/${companyId}`);
              }
            })
            .catch((e: unknown) => {
              if (e instanceof AxiosError) {
                setLoading(false);
                ErrorMessage(
                  e?.response?.data?.error?.message ?? "Something went wrong"
                );
              } else {
                setLoading(false);
                ErrorMessage("Something went wrong");
              }
            });
        } else {
          setLoading(false);
          SuccessMessage("Property added.");
          navigate(`/properties/${companyId}`);
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const saveAddMore = async () => {
    const allValues = getValues();
    const isValid = await trigger();

    let city = "";
    let state = "";
    googleAddress?.address_components?.forEach(
      (component: AddressComponent) => {
        if (component.types.includes("locality")) {
          city = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          state = component.short_name;
        }
      }
    );

    if (isValid) {
      setLoading(true);
      const payload = {
        name: allValues?.name,
        address: allValues?.address,
        city: city,
        state: state,
        is_property_billing_address: true,
        address_note: allValues?.address_note,
        category_ids: allValues?.category_ids,
        manager_id: allValues?.responsible_for_account,
        company_id: companyId,
        client_id: allValues?.select_client,
        client_contact_id: allValues?.client_contact_id,
      };

      createProperty(payload)
        .then((res: AxiosResponse) => {
          if (checklistFile && res && res?.data?.id) {
            uploadUserImage({
              owner_id: res?.data?.id,
              image: checklistFile as File | RcFile,
              image_type: "property_image",
            })
              .then((res) => {
                if (res) {
                  setLoading(false);
                  SuccessMessage("Property added.");
                  window.location.reload();
                }
              })
              .catch((e: unknown) => {
                if (e instanceof AxiosError) {
                  setLoading(false);
                  ErrorMessage(
                    e?.response?.data?.error?.message ?? "Something went wrong"
                  );
                } else {
                  setLoading(false);
                  ErrorMessage("Something went wrong");
                }
              });
          } else {
            setLoading(false);
            SuccessMessage("Property added.");
            window.location.reload();
          }
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
    }
  };

  return (
    <FullPageLayout loading={loading}>
      <Form
        className="propertyForm"
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Button className="btn-sm fixedTopBtn">
          <NeedHelp /> Need help?
        </Button>

        <div style={{ paddingBottom: 80 }}>
          <Row gutter={8} style={{ width: "672px" }}>
            <Col span={24}>
              <div
                className="title"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <h2> Add Property </h2>
                  <p>Property is a location where you schedule crew visits.</p>
                </div>
                <Button
                  htmlType="button"
                  className="outlined-btn btn-sm"
                  type="primary"
                >
                  <UploadIcon /> Bulk upload
                </Button>
              </div>
            </Col>

            <Col span={24}>
              <Card>
                <PropertyClient
                  propertyClientData={propertyFormData?.clients}
                  control={control}
                  companyId={companyId}
                  setClientId={setClientId}
                  selectedClient={selectedClient}
                  setSelectedClient={setSelectedClient}
                  setValue={setValue}
                />
              </Card>
              <Card>
                <Row gutter={20}>
                  <Col span={24} style={{ marginBottom: "16px" }}>
                    <h4> Property details </h4>
                  </Col>
                  <Col span={24} style={{ marginBottom: "24px" }}>
                    <UploadFull
                      saveUpload={saveUpload}
                      loading={false}
                      onImageDelete={() => null}
                      previewImage={previewImage}
                      checklistFile={checklistFile}
                      modalPreviewImage={modalPreviewImage}
                      setChecklistFile={setChecklistFile}
                      setPreviewImage={setPreviewImage}
                      setModalPreviewImage={setModalPreviewImage}
                      infoTextUploader="The picture helps others identify this property. It’s optional."
                    />
                  </Col>
                  <Col span={24}>
                    <InputField
                      fieldName="name"
                      label="Property name"
                      control={control}
                      defaultValue=""
                      iProps={{
                        placeholder: "Enter property name",
                      }}
                      isRequired
                      rules={{
                        required: "Property name is required.",
                      }}
                      validate={errors.name && "error"}
                      validMessage={errors.name && errors.name.message}
                    />

                    <AutoCompleteField
                      fieldName="address"
                      label="Property address"
                      control={control}
                      defaultValue=""
                      iProps={{
                        placeholder: "Search address",
                      }}
                      onPlaceChange={(place: Place) => setGoogleAddress(place)}
                      isRequired
                      rules={{
                        required: "Headquarters address is required.",
                      }}
                      validate={errors.address && "error"}
                      validMessage={errors.address && errors.address.message}
                    />

                    <div className="filterBox" style={{ marginBottom: "16px" }}>
                      <div className="switchBox">
                        <Switch />
                        Property and client’s billing addresses match
                      </div>
                    </div>

                    <InputField
                      fieldName="address_note"
                      label="Address note"
                      control={control}
                      defaultValue=""
                      iProps={{
                        placeholder: "Enter address note name",
                      }}
                      // isRequired
                      // rules={{
                      //   required: "Address note is required.",
                      // }}
                      // validate={errors.address_note && "error"}
                      // validMessage={
                      //   errors.address_note && errors.address_note.message
                      // }
                    />
                  </Col>
                  <Col span={12}>
                    <SelectFieldTags
                      fieldName="category_ids"
                      label="Categories"
                      control={control}
                      selectOption={propertyFormData?.category}
                      iProps={{
                        placeholder: "Select categories",
                        mode: "multiple",
                      }}
                      className="bottom_0"
                    />
                  </Col>
                  <Col span={12}>
                    <SelectField
                      fieldName="responsible_for_account"
                      label="Responsible for account"
                      control={control}
                      selectOption={propertyFormData?.managers}
                      iProps={{
                        placeholder: "Select a manager",
                      }}
                      className="bottom_0"
                      tooltipTitle="A manager overseeing this account - either a salesperson or an account manager, depending on the stage."
                    />
                  </Col>
                </Row>
              </Card>
              <Card>
                <PropertyContact
                  propertyContact={propertyContact}
                  clientId={clientId}
                  companyId={companyId}
                  control={control}
                  clientContactData={clientContactData}
                  selectedClient={selectedClient?.type}
                />
              </Card>
            </Col>
          </Row>

          <div className="fixed_btm_card">
            <Card>
              <div className="centered">
                <Button
                  htmlType="button"
                  className="outlined-btn"
                  onClick={() => navigate(`/properties/${companyId}`)}
                >
                  Cancel
                </Button>
                <div style={{ display: "flex", gap: "16px" }}>
                  <Button
                    htmlType="button"
                    className="outlined-btn"
                    type="primary"
                    onClick={handleSubmit(saveAddMore)}
                  >
                    Save & add one more
                  </Button>
                  <Button htmlType="submit" type="primary" className="mint-btn">
                    Save & close
                  </Button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </Form>
    </FullPageLayout>
  );
}
